import React, { Component } from "react";
import { postRequest, withRequest } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import { apiUrl } from "../../../utils/apiUrl";
import Loader from "../../general/Loader";
import AmonestacionesForm from "./Form";
import Modal from "../../general/Modal";
import DescuentoItem from "./DescuentoItem";
import { permisions } from "../../../utils/helpers";

class Amonestaciones extends Component {
    state = {
        amonestaciones: [],
        showCreate: false,
        loading: true
    };
    componentDidMount() {
        this.getAmonestaciones();
    }
    getAmonestaciones = async (url = null) => {
        const id = this.props.empleado.id;
        url = url ? url : `empleados/${id}/sanciones`;
        const amonestaciones = await this.props.request(url);

        if (amonestaciones.success) {
            this.setState({
                amonestaciones: amonestaciones.data,
                loading: false
            });
        }
    };
    removeAmonestacion = async (event, amonestacion) => {
        event.preventDefault();

        const { empleado } = this.props;

        const url = `empleados/${empleado.id}/sanciones/${amonestacion}`;
        const response = await postRequest(apiUrl(url), {}, 'delete');

        if (response.success) {
            this.getAmonestaciones();
            return;
        } else {
            this.setState({ errors: response.data.message });
        }
    };
    toggleCreateModal = () => {
        this.setState({
            showCreate: !this.state.showCreate
        });
    };
    render() {
        const { empleado } = this.props;
        const { amonestaciones, loading } = this.state;

        if (loading === 0) {
            return <Loader />;
        }
        return (
            <div>
                <div className='row m-b-20 descripcion-subpage'>
                    <div className='col'>
                        <h3>Descuentos Programados y Amonestaciones</h3>
                        <p><small>Los descuentos programados solo se aplican en las nóminas que coinciden con la fecha del descuento. Útil para descontar préstamos, amonestaciones y otros descuentos futuros de manera automática.</small></p>
                    </div>
                    <div className='col-md-3 text-right'>
                        {auth.canEdit(permisions.verEmpleados) && <button
                            onClick={this.toggleCreateModal}
                            className='au-btn au-btn-icon au-btn--green au-btn--small'>
                            Nuevo
                        </button>}
                    </div>
                </div>
                <div className='table descuentos-table tickets-table'>
                    <div className="descuentos-table-head">
                        <div>Monto</div>
                        <div>Descripción</div>
                        <div className="text-right">Fecha</div>
                        <div></div>
                    </div>
                    <div>
                        {amonestaciones.map(descuento => (
                            <DescuentoItem descuento={descuento} key={descuento.id} />
                        ))}
                    </div>
                </div>
                <Modal
                    show={this.state.showCreate}
                    blank={true}
                    toggle={this.toggleCreateModal}>
                    <AmonestacionesForm
                        toggle={this.toggleCreateModal}
                        empleadoId={empleado.id}
                        getAmonestaciones={this.getAmonestaciones}
                    />
                </Modal>
            </div>
        );
    }
}

export default withRequest(Amonestaciones);
